import {
  AccountCircle,
  CategoryOutlined,
  CurrencyRupeeOutlined,
  HomeOutlined,
} from "@mui/icons-material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";

const Footer = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState("recents");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <BottomNavigation
      className="!fixed !bottom-0 !shadow !shadow-gray-200 !border-t !border-solid !h-16 !w-full"
      value={value}
      onChange={handleChange}
    >
      <BottomNavigationAction
        label="Home"
        value="home"
        icon={<HomeOutlined />}
        onClick={() => navigate("/")}
      />
      <BottomNavigationAction
        label="Categories"
        value="categories"
        icon={<CategoryOutlined />}
        onClick={() => navigate("/categories")}
      />
      <BottomNavigationAction
        label="Earnings"
        value="earning"
        icon={<CurrencyRupeeOutlined />}
        onClick={() => navigate("/earnings")}
      />
      <BottomNavigationAction
        label="Profile"
        value="profile"
        icon={<AccountCircle />}
        onClick={() =>
          localStorage.getItem("bhaarattoken")
            ? navigate("/profile")
            : navigate("/login")
        }
      />
    </BottomNavigation>
  );
};

export default Footer;
